// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Tax return table: semantic column classes so layout works with responsive column visibility */
:host {
  display: block;
  width: 100%;
  max-width: 100%;
}

.table-container.tax-return-table-wrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 80px;
  box-sizing: border-box;
}

::ng-deep .tax-return-table {
  width: 100%;
  max-width: 100%;
  min-width: 200px;
  table-layout: auto;
  border-collapse: collapse;
  border: 1px solid #dee2e6;
  /* Column widths by semantic class (works with any visible column set) */
  /* Summary row (e.g. إجمالي ضريبة المبيعات) */
  /* Total rows at bottom */
  /* Expanded detail row */
}
::ng-deep .tax-return-table .table-header-cell {
  padding: 0.5rem 0.75rem;
  border: 1px solid #dee2e6;
  background: #f8f9fa;
  font-weight: 600;
  white-space: normal;
  word-wrap: break-word;
}
::ng-deep .tax-return-table .table-cell {
  padding: 0.5rem 0.75rem;
  border: 1px solid #dee2e6;
  vertical-align: middle;
}
::ng-deep .tax-return-table .col-section {
  min-width: 70px;
  max-width: 160px;
  white-space: normal;
  word-wrap: break-word;
}
::ng-deep .tax-return-table .col-code {
  min-width: 48px;
  max-width: 100px;
  white-space: nowrap;
}
::ng-deep .tax-return-table .col-desc {
  min-width: 90px;
  white-space: normal;
  word-wrap: break-word;
}
::ng-deep .tax-return-table .col-num {
  min-width: 64px;
  white-space: nowrap;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 500;
}
::ng-deep .tax-return-table .col-more {
  width: 44px;
  min-width: 44px;
  max-width: 44px;
  text-align: center;
  padding: 0.35rem;
  background: #f8f9fa;
}
::ng-deep .tax-return-table tr.summary-row,
::ng-deep .tax-return-table tr.summary-row:hover {
  background-color: #dcfce7 !important;
  font-weight: 600;
}
::ng-deep .tax-return-table tr.summary-row .table-cell {
  font-weight: 600;
}
::ng-deep .tax-return-table tr.table-total-row,
::ng-deep .tax-return-table tr.table-total-row:hover {
  background-color: #e9ecef !important;
  font-weight: 600;
}
::ng-deep .tax-return-table tr.table-total-row .table-cell.table-total-cell {
  font-weight: 600;
  border: 1px solid #dee2e6;
}
::ng-deep .tax-return-table tr.table-total-row .table-cell.table-total-cell.col-num {
  font-size: 0.875rem;
  text-align: center;
}
::ng-deep .tax-return-table tr.expand-detail-row td {
  padding: 0.5rem 0.75rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  vertical-align: top;
}

.more-btn {
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}

.info-card-table {
  width: 100%;
}
.info-card-table .key-label {
  font-weight: 600;
  padding-right: 0.5rem;
  vertical-align: top;
  min-width: 100px;
}
.info-card-table .table-cell {
  padding: 0.25rem 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/table-tax-return/table-tax-return.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,gGAAA;AACA;EACE,cAAA;EACA,WAAA;EACA,eAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,oBAAA;EACA,sBAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EAiBA,wEAAA;EAqCA,6CAAA;EAUA,yBAAA;EAeA,wBAAA;AAzEF;AAJE;EACE,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAMJ;AAHE;EACE,uBAAA;EACA,yBAAA;EACA,sBAAA;AAKJ;AADE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAGJ;AAAE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AACE;EACE,eAAA;EACA,mBAAA;EACA,qBAAA;AACJ;AAEE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAKE;;EAEE,oCAAA;EACA,gBAAA;AAHJ;AAKE;EACE,gBAAA;AAHJ;AAOE;;EAEE,oCAAA;EACA,gBAAA;AALJ;AAOE;EACE,gBAAA;EACA,yBAAA;AALJ;AAOE;EACE,mBAAA;EACA,kBAAA;AALJ;AASE;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AARF;;AAWA;EACE,WAAA;AARF;AASE;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAPJ;AASE;EACE,kBAAA;AAPJ","sourcesContent":["/* Tax return table: semantic column classes so layout works with responsive column visibility */\n:host {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.table-container.tax-return-table-wrapper {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 80px;\n  box-sizing: border-box;\n}\n\n::ng-deep .tax-return-table {\n  width: 100%;\n  max-width: 100%;\n  min-width: 200px;\n  table-layout: auto;\n  border-collapse: collapse;\n  border: 1px solid #dee2e6;\n\n  .table-header-cell {\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #dee2e6;\n    background: #f8f9fa;\n    font-weight: 600;\n    white-space: normal;\n    word-wrap: break-word;\n  }\n\n  .table-cell {\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #dee2e6;\n    vertical-align: middle;\n  }\n\n  /* Column widths by semantic class (works with any visible column set) */\n  .col-section {\n    min-width: 70px;\n    max-width: 160px;\n    white-space: normal;\n    word-wrap: break-word;\n  }\n\n  .col-code {\n    min-width: 48px;\n    max-width: 100px;\n    white-space: nowrap;\n  }\n\n  .col-desc {\n    min-width: 90px;\n    white-space: normal;\n    word-wrap: break-word;\n  }\n\n  .col-num {\n    min-width: 64px;\n    white-space: nowrap;\n    text-align: center;\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n\n  .col-more {\n    width: 44px;\n    min-width: 44px;\n    max-width: 44px;\n    text-align: center;\n    padding: 0.35rem;\n    background: #f8f9fa;\n  }\n\n  /* Summary row (e.g. إجمالي ضريبة المبيعات) */\n  tr.summary-row,\n  tr.summary-row:hover {\n    background-color: #dcfce7 !important;\n    font-weight: 600;\n  }\n  tr.summary-row .table-cell {\n    font-weight: 600;\n  }\n\n  /* Total rows at bottom */\n  tr.table-total-row,\n  tr.table-total-row:hover {\n    background-color: #e9ecef !important;\n    font-weight: 600;\n  }\n  tr.table-total-row .table-cell.table-total-cell {\n    font-weight: 600;\n    border: 1px solid #dee2e6;\n  }\n  tr.table-total-row .table-cell.table-total-cell.col-num {\n    font-size: 0.875rem;\n    text-align: center;\n  }\n\n  /* Expanded detail row */\n  tr.expand-detail-row td {\n    padding: 0.5rem 0.75rem;\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    vertical-align: top;\n  }\n}\n\n.more-btn {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.info-card-table {\n  width: 100%;\n  .key-label {\n    font-weight: 600;\n    padding-right: 0.5rem;\n    vertical-align: top;\n    min-width: 100px;\n  }\n  .table-cell {\n    padding: 0.25rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
